// src/pages/Login.jsx - FIXED WITH HEADER
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import ApiService from '../services/apiService';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [showDeviceModal, setShowDeviceModal] = useState(false);
  const [activeDevices, setActiveDevices] = useState([]);
  const [loggingOutDevice, setLoggingOutDevice] = useState(null);
  
  var isGJ = false;
  const domain = window.location.hostname;
  if (domain.includes("gojuris.ai")) {
    isGJ = true;
  }

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setError('Email address or Mobile No is required');
      return;
    }

    if (!password.trim()) {
      setError('Password is required');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      console.log('🔐 Attempting login...');

      const loginData = {
        username: email,
        password: password
      };

      const result = await ApiService.loginUser(loginData);
      console.log('✅ Login successful:', result);

      if (result.userEmail || email) {
        localStorage.setItem('userEmail', result.userEmail || email);
      }

      if (result.userData) {
        localStorage.setItem('userData', JSON.stringify(result.userData));
      } else if (result.user) {
        localStorage.setItem('userData', JSON.stringify(result.user));
      }

      const permissionsData = await ApiService.getUserPermissions();
      localStorage.setItem('userp', JSON.stringify(permissionsData));

      navigate('/dashboard');

    } catch (error) {
      console.error('❌ Login error:', error);
      debugger;
       if (error.message === 'DEVICE_LIMIT_EXCEEDED' && error.devices) {
        setActiveDevices(error.devices);
        setShowDeviceModal(true);
        setError('');
      }
      else if (error.message.includes('Invalid') || error.message.includes('incorrect')) {
        setError('Invalid email or password. Please try again.');
      } else if (error.message.includes('not found')) {
        setError('Account not found. Please check your email or sign up.');
      } else {
        setError(error.message || 'Login failed. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };
  // Handle logout from a specific device
  const handleLogoutDevice = async (sessionId) => {
    setLoggingOutDevice(sessionId);
    try {
      await ApiService.logoutDeviceWithCredentials(sessionId, {
        username: email,
        password: password
      });
      // Remove device from list (using PascalCase from C#)
      setActiveDevices(prev => prev.filter(d => d.SessionId !== sessionId));
      // If no more devices, close modal and retry login
      if (activeDevices.length <= 1) {
        setShowDeviceModal(false);
        // Small delay then retry login
        setTimeout(() => {
          handleLogin({ preventDefault: () => {} });
        }, 500);
      }
    } catch (err) {
      console.error('Failed to logout device:', err);
      setError('Failed to logout device. Please try again.');
      setShowDeviceModal(false);
    } finally {
      setLoggingOutDevice(null);
    }
  };
 // Format date and time for display
  const formatDateTime = (dateStr) => {
    if (!dateStr) return 'Unknown';
    const date = new Date(dateStr);
    const dateOptions = { day: 'numeric', month: 'short', year: 'numeric' };
    const timeOptions = { hour: '2-digit', minute: '2-digit', hour12: true };
    return `${date.toLocaleDateString('en-IN', dateOptions)} at ${date.toLocaleTimeString('en-IN', timeOptions)}`;
  };
  const handleSignUp = () => {
    navigate('/signup');
  };

  return (
    <>
      <Header />
      {showDeviceModal && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          backdropFilter: 'blur(4px)'
        }}>
          <div className="device-modal" style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            padding: '0',
            maxWidth: '450px',
            width: '90%',
            boxShadow: '0 8px 32px rgba(139, 92, 246, 0.25)',
            overflow: 'hidden'
          }}>
            {/* Header */}
            <div style={{
              background: 'linear-gradient(135deg, #c41849 0%, #c41849 50%, #c41849 100%)',
              padding: '20px 24px',
              color: 'white'
            }}>
              <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
                <i className="bx bx-devices" style={{ marginRight: '8px' }}></i>
                Linked Devices ({activeDevices.length}/1)
              </h3>
            </div>

            <div style={{ padding: '20px 24px' }}>
              <p style={{ color: '#c41849', fontSize: '14px', margin: '0 0 16px 0', fontWeight: '500' }}>
                To "Log in", please <strong>"Log out"</strong> from the devices mentioned below.
              </p>

              <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                {activeDevices.map((device, index) => (
                  <div key={device.SessionId || index} style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '14px 16px',
                    border: '1px solid #e2e8f0',
                    backgroundColor: '#f8fafc',
                    borderRadius: '12px',
                    marginBottom: '10px'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <div style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '10px',
                        background: 'linear-gradient(135deg, #c41849 0%, #c41849 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white'
                      }}>
                        <i className={`bx ${device.DeviceName?.includes('Android') || device.DeviceName?.includes('iPhone') ? 'bx-mobile-alt' : 'bx-laptop'}`} style={{ fontSize: '20px' }}></i>
                      </div>
                      <div>
                        <div style={{ fontWeight: '600', fontSize: '14px', color: '#1e293b' }}>
                          {device.DeviceName || 'Unknown'} ({device.Browser || 'Unknown'})
                        </div>
                        <div style={{ color: '#64748b', fontSize: '12px', marginTop: '2px' }}>
                          Last Logged In: {formatDateTime(device.LoginTime)}
                        </div>
                        <div style={{ color: '#64748b', fontSize: '12px' }}>
                          IP: {device.IpAddress || 'Unknown'}
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={() => handleLogoutDevice(device.SessionId)}
                      disabled={loggingOutDevice === device.SessionId}
                      style={{
                        backgroundColor: '#fee2e2',
                        border: 'none',
                        color: '#dc2626',
                        cursor: 'pointer',
                        fontWeight: '600',
                        fontSize: '13px',
                        padding: '8px 16px',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        transition: 'all 0.2s'
                      }}
                    >
                      {loggingOutDevice === device.SessionId ? (
                        <>
                          <span className="spinner-border spinner-border-sm"></span>
                          Logging out...
                        </>
                      ) : (
                        <>
                          <i className="bx bx-log-out"></i>
                          Log out
                        </>
                      )}
                    </button>
                  </div>
                ))}
              </div>

              <div style={{
                backgroundColor: '#fef2f2',
                border: '1px solid #fecaca',
                borderRadius: '10px',
                padding: '12px 16px',
                marginTop: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <i className="bx bx-error-circle" style={{ color: '#dc2626', fontSize: '20px' }}></i>
                <span style={{ color: '#dc2626', fontSize: '14px', fontWeight: '500' }}>
                  Your Device limit exceeded!
                </span>
              </div>

              <button
                onClick={() => setShowDeviceModal(false)}
                style={{
                  width: '100%',
                  padding: '14px',
                  background: 'linear-gradient(135deg, #c41849 0%, #dc2626 50%, #c41849 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px',
                  marginTop: '16px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '15px',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  boxShadow: '0 4px 15px rgba(139, 92, 246, 0.3)'
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="modern-login-page">
        {/* Left Side - Login Form */}
        <div className="login-left-panel">
          <div className="login-form-container">
           

            {/* Form */}
            <div className="login-form-content">
              <h1 className="login-title">Welcome back</h1>
              <p className="login-subtitle">Enter your credentials to access your account</p>

              {/* Error Alert */}
              {error && (
                <div className="error-alert">
                  <i className="bx bx-error-circle"></i>
                  <span>{error}</span>
                </div>
              )}

              <form onSubmit={handleLogin} className="login-form">
                {/* Email Field */}
                <div className="form-field">
                  <label className="field-label">Email or Mobile</label>
                  <div className="input-wrapper">
                    <i className="bx bx-envelope input-icon"></i>
                    <input
                      type="text"
                      className="form-input"
                      placeholder="Enter your email or mobile"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        if (error) setError('');
                      }}
                      disabled={isLoading}
                      required
                    />
                  </div>
                </div>

                {/* Password Field */}
                <div className="form-field">
                  <label className="field-label">Password</label>
                  <div className="input-wrapper">
                    <i className="bx bx-lock-alt input-icon"></i>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className="form-input"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        if (error) setError('');
                      }}
                      disabled={isLoading}
                      required
                    />
                    <button
                      type="button"
                      className="password-toggle-btn"
                      onClick={() => setShowPassword(!showPassword)}
                      disabled={isLoading}
                    >
                      <i className={showPassword ? 'bx bx-hide' : 'bx bx-show'}></i>
                    </button>
                  </div>
                </div>

                {/* Forgot Password */}
                <div className="forgot-password-section">
                  <a href="#" className="forgot-password-link">Forgot password?</a>
                </div>

                {/* Login Button */}
                <button
                  type="submit"
                  className="login-btn"
                  disabled={isLoading || !email.trim() || !password.trim()}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner"></span>
                      <span>Signing in...</span>
                    </>
                  ) : (
                    <>
                      <span>Sign In</span>
                      <i className="bx bx-right-arrow-alt"></i>
                    </>
                  )}
                </button>
              </form>

              {/* Divider */}
              <div className="divider">
                <span>OR</span>
              </div>

              {/* Social Login */}
              <div className="social-login">
                <button className="social-btn" disabled={isLoading}>
                  <i className="bx bxl-google"></i>
                  <span>Continue with Google</span>
                </button>
                <button className="social-btn" disabled={isLoading}>
                  <i className="bx bxl-apple"></i>
                  <span>Continue with Apple</span>
                </button>
              </div>

              {/* Sign Up Link */}
              <div className="signup-section">
                <p>Don't have an account?</p>
                <button onClick={handleSignUp} className="signup-link" disabled={isLoading}>
                  Create an account
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Gradient Background */}
        <div className="login-right-panel">
          <div className="gradient-content">
            {/* Decorative Elements */}
            <div className="gradient-decoration decoration-1"></div>
            <div className="gradient-decoration decoration-2"></div>
            <div className="gradient-decoration decoration-3"></div>

            {/* Content */}
            <div className="gradient-text-content">
              <div className="ai-badge">
                <i className="bx bx-brain"></i>
                <span>Fast and Reliable</span>
              </div>
              
              <h2 className="gradient-title">
                {isGJ ? 'LJ Soft Online' : 'LJ Soft Online'}
              </h2>
              
              <p className="gradient-description">
                Research Made Effortless
              </p>

              {/* Features */}
              <div className="feature-list">
                <div className="feature-item">
                  <i className="bx bx-check-circle"></i>
                  <span>Fast and Reliable Legal Search</span>
                </div>
                <div className="feature-item">
                  <i className="bx bx-check-circle"></i>
                  <span>10M+ Legal Documents</span>
                </div>
                <div className="feature-item">
                  <i className="bx bx-check-circle"></i>
                  <span>Real-Time Updates</span>
                </div>
              </div>

              {/* Illustration */}
              <div className="ai-illustration">
                <i className="bx bx-search-alt-2"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        /* ============================================
           REMOVE TOP WHITE SPACE
        ============================================ */
        body {
          margin: 0 !important;
          padding: 0 !important;
        }

        /* ============================================
           MODERN LOGIN PAGE
        ============================================ */
        .modern-login-page {
          display: flex;
          min-height: calc(100vh - 80px);
          margin-top: 0;
          padding-top: 0;
        }

        /* ============================================
           LEFT PANEL - LOGIN FORM
        ============================================ */
        .login-left-panel {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 40px 20px;
          background: #ffffff;
          overflow-y: auto;
        }

        .login-form-container {
          width: 100%;
          max-width: 480px;
          animation: slideInLeft 0.6s ease;
        }

        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        /* Logo */
        .login-logo {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 40px;
        }

        .logo-img {
          width: 48px;
          height: 48px;
          object-fit: contain;
        }

        .logo-text {
          font-size: 28px;
          font-weight: 800;
          background: linear-gradient(135deg, #E91E63, #c41849);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin: 0;
        }

        /* Form Content */
        .login-form-content {
          width: 100%;
        }

        .login-title {
          font-size: 32px;
          font-weight: 800;
          color: #1a1a1a;
          margin-bottom: 8px;
        }

        .login-subtitle {
          font-size: 15px;
          color: #666;
          margin-bottom: 32px;
        }

        /* Error Alert */
        .error-alert {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 14px 16px;
          background: #fee;
          border: 1px solid #fcc;
          border-radius: 12px;
          color: #c33;
          font-size: 14px;
          margin-bottom: 24px;
          animation: shake 0.4s ease;
        }

        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }

        .error-alert i {
          font-size: 20px;
        }

        /* Form Fields */
        .login-form {
          display: flex;
          flex-direction: column;
          gap: 20px;
          margin-bottom: 24px;
        }

        .form-field {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .field-label {
          font-size: 14px;
          font-weight: 600;
          color: #333;
        }

        .input-wrapper {
          position: relative;
          display: flex;
          align-items: center;
        }

        .input-icon {
          position: absolute;
          left: 16px;
          font-size: 20px;
          color: #999;
          pointer-events: none;
        }

        .form-input {
          width: 100%;
          padding: 14px 16px 14px 48px;
          border: 2px solid #e0e0e0;
          border-radius: 12px;
          font-size: 15px;
          color: #333;
          background: #fafafa;
          transition: all 0.3s ease;
        }

        .form-input:focus {
          outline: none;
          border-color: #E91E63;
          background: white;
          box-shadow: 0 0 0 4px rgba(245, 166, 35, 0.1);
        }

        .form-input::placeholder {
          color: #999;
        }

        .form-input:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .password-toggle-btn {
          position: absolute;
          right: 16px;
          background: transparent;
          border: none;
          color: #999;
          font-size: 20px;
          cursor: pointer;
          padding: 4px;
          transition: color 0.3s ease;
        }

        .password-toggle-btn:hover {
          color: #E91E63;
        }

        /* Forgot Password */
        .forgot-password-section {
          text-align: right;
          margin-top: -8px;
          margin-bottom: 8px;
        }

        .forgot-password-link {
          font-size: 14px;
          color: #E91E63;
          text-decoration: none;
          font-weight: 500;
          transition: color 0.3s ease;
        }

        .forgot-password-link:hover {
          color: #c41849;
        }
/* Login Button - FIXED HOVER COLOR */
.login-btn {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #E91E63, #c41849);
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(245, 166, 35, 0.3);
}

.login-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #E91E64, #F5316D);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(245, 166, 35, 0.5);
}

.login-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 4px 15px rgba(245, 166, 35, 0.4);
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: linear-gradient(135deg, #E91E63, #c41849);
}

        .login-btn i {
          font-size: 20px;
        }

        .spinner {
          width: 18px;
          height: 18px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top-color: white;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        /* Divider */
        .divider {
          display: flex;
          align-items: center;
          text-align: center;
          margin: 24px 0;
          color: #999;
          font-size: 14px;
        }

        .divider::before,
        .divider::after {
          content: '';
          flex: 1;
          border-bottom: 1px solid #e0e0e0;
        }

        .divider span {
          padding: 0 16px;
        }

        /* Social Login */
        .social-login {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-bottom: 24px;
        }

        .social-btn {
          width: 100%;
          padding: 14px 16px;
          background: white;
          border: 2px solid #e0e0e0;
          border-radius: 12px;
          color: #333;
          font-size: 15px;
          font-weight: 500;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transition: all 0.3s ease;
        }

        .social-btn:hover:not(:disabled) {
          border-color: #E91E63;
          background: #fffbf5;
        }

        .social-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .social-btn i {
          font-size: 20px;
        }

        /* Sign Up Section */
        .signup-section {
          text-align: center;
          padding-top: 24px;
          border-top: 1px solid #e0e0e0;
        }

        .signup-section p {
          font-size: 15px;
          color: #666;
          margin-bottom: 8px;
        }

        .signup-link {
          background: transparent;
          border: none;
          color: #E91E63;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: color 0.3s ease;
        }

        .signup-link:hover {
          color: #c41849;
        }

        /* ============================================
           RIGHT PANEL - GRADIENT BACKGROUND
        ============================================ */
        .login-right-panel {
          flex: 1;
          background: linear-gradient(135deg, #E91E63 0%, #E91E64 50%, #c41849 100%);
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .gradient-content {
          position: relative;
          z-index: 1;
          padding: 60px 40px;
          text-align: center;
          animation: slideInRight 0.8s ease;
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        /* Decorations */
        .gradient-decoration {
          position: absolute;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
        }

        .decoration-1 {
          width: 400px;
          height: 400px;
          top: -100px;
          right: -100px;
          animation: float 20s ease-in-out infinite;
        }

        .decoration-2 {
          width: 300px;
          height: 300px;
          bottom: -80px;
          left: -80px;
          animation: float 15s ease-in-out infinite reverse;
        }

        .decoration-3 {
          width: 200px;
          height: 200px;
          top: 50%;
          left: 20%;
          animation: float 25s ease-in-out infinite;
        }

        @keyframes float {
          0%, 100% {
            transform: translate(0, 0) scale(1);
          }
          33% {
            transform: translate(30px, -30px) scale(1.1);
          }
          66% {
            transform: translate(-30px, 30px) scale(0.9);
          }
        }

        /* Gradient Content */
        .gradient-text-content {
          position: relative;
          z-index: 2;
        }

        .ai-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 10px 24px;
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          border-radius: 50px;
          border: 1px solid rgba(255, 255, 255, 0.3);
          color: white;
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 32px;
        }

        .ai-badge i {
          font-size: 18px;
        }

        .gradient-title {
          font-size: 56px;
          font-weight: 800;
          color: white;
          margin-bottom: 16px;
          text-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        }

        .gradient-description {
          font-size: 24px;
          color: rgba(255, 255, 255, 0.95);
          margin-bottom: 48px;
        }

        /* Features */
        .feature-list {
          display: flex;
          flex-direction: column;
          gap: 16px;
          margin-bottom: 48px;
        }

        .feature-item {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          color: white;
          font-size: 16px;
          font-weight: 500;
        }

        .feature-item i {
          font-size: 24px;
        }

        /* AI Illustration */
        .ai-illustration {
          width: 120px;
          height: 120px;
          margin: 0 auto;
          background: rgba(255, 255, 255, 0.15);
          backdrop-filter: blur(10px);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid rgba(255, 255, 255, 0.3);
          animation: pulse 3s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
          }
          50% {
            transform: scale(1.05);
            box-shadow: 0 0 0 20px rgba(255, 255, 255, 0);
          }
        }

        .ai-illustration i {
          font-size: 60px;
          color: white;
        }

        /* ============================================
           RESPONSIVE
        ============================================ */
        @media (max-width: 1024px) {
          .login-right-panel {
            display: none;
          }

          .login-left-panel {
            flex: 1;
          }
        }

        @media (max-width: 768px) {
          .modern-login-page {
            min-height: calc(100vh - 60px);
          }

          .login-left-panel {
            padding: 24px 16px;
          }

          .login-form-container {
            max-width: 100%;
          }

          .login-title {
            font-size: 28px;
          }

          .login-subtitle {
            font-size: 14px;
          }
        }
      `}</style>
    </>
  );
};

export default Login;